
import React from "react";
import "./Badge.css"

const Badge = () =>{
    return(
        <div className="container mt-6">
            <div className="card">
                <div className="card-header">
                    <h3 className="h5">Badge</h3>
                </div>
                <div className="card-block">
                    <div className="badge-sec">
                        <span class="badge bg-primary">Primary</span>
                        <span class="badge bg-secondary">Secondary</span>
                        <span class="badge bg-success">Success</span>
                        <span class="badge bg-danger">Danger</span>
                        <span class="badge bg-warning text-dark">Warning</span>
                        <span class="badge bg-info text-dark">Info</span>
                        <span class="badge bg-light text-dark">Light</span>
                        <span class="badge bg-dark">Dark</span>
                    </div>
                    <div className="badge-sec mt-3">
                        <span class="badge rounded-pill bg-primary">Primary</span>
                        <span class="badge rounded-pill bg-secondary">Secondary</span>
                        <span class="badge rounded-pill bg-success">Success</span>
                        <span class="badge rounded-pill bg-danger">Danger</span>
                        <span class="badge rounded-pill bg-warning text-dark">Warning</span>
                        <span class="badge rounded-pill bg-info text-dark">Info</span>
                        <span class="badge rounded-pill bg-light text-dark">Light</span>
                        <span class="badge rounded-pill bg-dark">Dark</span>
                    </div>
                    <div className="badge-sec mt-3">
                        <button type="button" class="btn btn-primary">
                            Notifications <span class="badge bg-secondary">4</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default Badge;